import { useEffect, useState } from "react";
import { Download } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api/proposal` : "";
const STORE = "am-proposal-key";

// Shows only for visitors who arrived with a valid private link (?proposal=<key>)
export function ProposalLink() {
  const [key, setKey] = useState("");
  useEffect(() => {
    if (!API) return;
    const fromUrl = new URLSearchParams(window.location.search).get("proposal");
    const candidate = fromUrl ?? sessionStorage.getItem(STORE) ?? "";
    if (!candidate) return;
    fetch(`${API}/check?key=${encodeURIComponent(candidate)}`)
      .then((r) => r.json())
      .then((d) => {
        if (d?.ok) {
          sessionStorage.setItem(STORE, candidate);
          setKey(candidate);
          if (!sessionStorage.getItem(`${STORE}-alerted`)) {
            sessionStorage.setItem(`${STORE}-alerted`, "1");
            fetch(`${API}/opened?key=${encodeURIComponent(candidate)}`, { method: "POST" }).catch(() => {});
          }
        }
      })
      .catch(() => {});
  }, []);
  if (!key) return null;
  return (
    <a href={`${API}?key=${encodeURIComponent(key)}`} data-testid="am-footer-proposal"
      className="inline-flex items-center gap-2 rounded-full border border-white/80 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white hover:text-[var(--am-blue)]">
      <Download size={15} aria-hidden /> Download proposal (PDF)
    </a>
  );
}
